(function($, undefined) {
	
	'use strict';
	var ticketListHeader;

    var toggleTicketList = function() {
        var t = $(this);
        var parent = t.closest('.tickets-list-outer-ctn');
        var list = parent.find('.tickets-list-content-ctn');

        if (parent.hasClass('list-open')) {
            parent.removeClass('list-open');
            list.slideUp(300);
        } else {
            parent.addClass('list-open');
            list.slideDown(300);
        }
    };

	var init = function () {
        ticketListHeader = $('.tickets-list-header-ctn');

        ticketListHeader.click(toggleTicketList);
	};
	
    $(window).on('load',function(){
        init();
    });
	
})(jQuery);
